module.exports = __webpack_public_path__ + "img/icon_search.d263594.svg";